module.exports = __webpack_public_path__ + "img/icon-stock-zone.6ea69c2b.png";